exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-2ff6e95a] {\n  backface-visibility: hidden;\n  will-change: height;\n}\n", ""]);

// exports
